import { useCallback, useState } from "react";
import { getVolumeValue } from "../utils/playerVolume";

const getVolumeValidValue = (value) => Math.max(0, Math.min(100, value));

export const useSetValidVolume = () => {
  const [volume, setVolume] = useState(() => Number(getVolumeValue()) * 100);

  const setValidVolume = useCallback((value) => {
    if (typeof value === "function") {
      setVolume((actualVolume) => getVolumeValidValue(value(actualVolume)));
    } else {
      setVolume(getVolumeValidValue(value));
    }
  }, []);

  return [volume, setValidVolume];
};
